// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { FeatureFlagService } from './feature-flag.service';

@Injectable({
    providedIn: 'root',
})
export class RouteGuardService {
    private routeLogging = false;
    constructor(private readonly featureFlagService: FeatureFlagService) {
        this.routeLogging = this.featureFlagService.getDefaultFeatureConfiguration('routeGuardLoggingAppDebugging');
    }

    logRouteGuard(className: string, canActivateEvaluation: boolean) {
        if (this.routeLogging) {
            if (!canActivateEvaluation) {
                console.error(`${className} evaluated canEvaluate to false preventing route from activating.`);
            } else {
                console.info(`${className} evaluated canEvaluate to true`);
            }
        }
    }
}
